interface PaginationControlsProps {
  totalItems: number;
  page: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  className?: string;
}

export function PaginationControls({
  totalItems,
  page,
  pageSize,
  onPageChange,
  className,
}: PaginationControlsProps) {
  const totalPages = Math.ceil(totalItems / pageSize);
  if (totalPages <= 1) return null;

  const safePage = Math.min(Math.max(page, 0), totalPages - 1);
  const start = safePage * pageSize + 1;
  const end = Math.min((safePage + 1) * pageSize, totalItems);

  return (
    <div
      className={`flex items-center justify-between mt-3 text-xs text-gray-600 ${className ?? ''}`.trim()}
    >
      <span>
        {start}–{end} of {totalItems}
      </span>
      <div className="flex items-center gap-1">
        <button
          disabled={safePage === 0}
          onClick={() => onPageChange(safePage - 1)}
          className="px-2 py-1 rounded border border-surface-4 disabled:opacity-30 hover:bg-surface-3 transition-colors"
        >
          ‹ Prev
        </button>
        <button
          disabled={safePage >= totalPages - 1}
          onClick={() => onPageChange(safePage + 1)}
          className="px-2 py-1 rounded border border-surface-4 disabled:opacity-30 hover:bg-surface-3 transition-colors"
        >
          Next ›
        </button>
      </div>
    </div>
  );
}